// extracted by mini-css-extract-plugin
module.exports = {"FrontpageDatePicker":"FrontpageDatePickerWrapper_FrontpageDatePicker__JjwZi"};